import { defineMessages } from 'react-intl';

export default defineMessages({
  loadingText: {
    id: 'Loading.loadingText',
    description: 'Texto del loading',
    defaultMessage: 'Cargando...',
  },
});
